<template>
  <div class="achievement mt-1px">
    <div v-if="!isEmpty(data.spinup)" class="spinUp">
      <div data-aos="fade-up" class="background">
        <i18n-t class="textBlock font40px" :keypath="data.spinup.text" tag="div" scope="global">
          <template #spinup_date>
            <span class="font64px highlight">{{ data.spinup.date }}</span>
          </template>
        </i18n-t>
        <i18n-t class="section font40px" :keypath="data.spinup.text_2" tag="div" scope="global">
          <template #spinup_ratio>
            <CountAnimation class="font46px highlight" :number="data.spinup.ratio" unit="x" :color="`#55FFE4`" tag="span">
            </CountAnimation>
          </template>
          <template #unit>
            <span class="units font46px highlight">{{ $t('unit.multiplier')}}</span>
          </template>
          <template #spinup_reward>
            <CountAnimation class="font64px highlight" :number="data.spinup.reward" :currency="true" :color="`#FF5692`" tag="span">
            </CountAnimation>
          </template>
        </i18n-t>
        <img data-aos="fade-up" class="coin_left" :src="require('@img/decorations/coin_left.png')">
        <img class="wheel" :src="require('@img/decorations/wheel.png')"/>
        <img data-aos="fade-up" class="coin_right" :src="require('@img/decorations/coin_right.png')">
        <img data-aos="fade-up" class="coin_front" :src="require('@img/decorations/coin_front.png')">
      </div>
    </div>
    <div v-if="!isEmpty(data.mtt)" class="mtt">
      <div data-aos="fade-up" data-aos-delay="400" class="background">
        <div class="confetti">
          <img class="image" :src="require('@img/decorations/confetti.png')">
        </div>
        <i18n-t data-aos="fade-up" class="textBlock font40px" :keypath="data.mtt.text" tag="div" scope="global">
          <template #mtt_date>
            <span class="font64px highlight">{{ data.mtt.date }}</span>
          </template>
        </i18n-t>
        <i18n-t data-aos="fade-up" class="textBlock font40px" :keypath="data.mtt.text_2" tag="div" scope="global">
          <template #mtt_name>
            <span class="font46px highlight">{{ data.mtt.name }}</span>
          </template>
          <template #no>
            <span class="font46px highlight">{{ $t('unit.num') }}</span>
          </template>
          <template #unit2>
            <span class="font46px highlight">{{ $t('unit.num2') }}</span>
          </template>
          <template #mtt_rank>
            <CountAnimation class="font46px highlight" :number="data.mtt.rank" :color="`#55FFE4`" tag="span">
            </CountAnimation>
          </template>
          <template #mtt_reward>
            <CountAnimation class="font64px highlight" :number="data.mtt.reward" :currency="true" :color="`#FF5692`" tag="span">
            </CountAnimation>
          </template>
        </i18n-t>
      </div>
    </div>
    <div v-if="!isEmpty(data.rg)" class="rg">
      <div data-aos="fade-up" class="background">
        <i18n-t data-aos="fade-up"  class="textBlock font40px" :keypath="data.rg.text" tag="div" scope="global">
          <template #rg_date>
            <span class="font64px highlight">{{ data.rg.date }}</span>
          </template>
          <template #rg_reward>
            <CountAnimation class="font64px highlight" :number="data.rg.reward " :fixed="2" unit="$" :currency="true" :color="`#55FFE4`">
            </CountAnimation>
          </template>
        </i18n-t>
        <i18n-t data-aos="fade-up"  class="section font40px" :keypath="data.rg.text_2" tag="div" scope="global">
          <template #rg_reward>
            <CountAnimation class="font64px highlight" :number="data.rg.reward " :fixed="2" unit="$" :currency="true" :color="`#FF5692`" tag="span">
            </CountAnimation>
          </template>
        </i18n-t>
        <img data-aos="fade-up" class="light" :src="require('@img/keyVisual/light.png')" />
        <img data-aos="fade-up" data-aos-delay="100" class="bg_11" :src="require('@img/keyVisual/bg_11.png')" />
        <img data-aos="fade-up" data-aos-delay="300" class="bg_11_king" :src="require('@img/keyVisual/bg_11_king.png')">
        <img data-aos="fade-up" data-aos-delay="300" class="confetti_11"  :src="require('@img/decorations/confetti_11.png')">
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";

const props = defineProps({
  data: Object // achievement
})

function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}
</script>

<style lang="scss" scoped>
.achievement {
  position: relative;
  z-index: 1;
  // background-color: #2A2A3B;
  .spinUp {
    position: relative;
    .background {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      text-align: center;
      background-image: url('~@img/keyVisual/bg_9.png');
      background-position: bottom;
      background-size: contain;
      background-repeat: no-repeat;
      padding-top: 15%;
      width: 100%;
      height: 1337px;
      @media (max-width: $containerWidth) {
          height: pxToVw(1337px);
      }
    }
    .units {
      color:#55FFE4;
    }
    .textBlock {
      width: 80%;
      margin-top: 35%;
      white-space: pre-line;
    }
    .section {
      width: 80%;
      margin-top: 8%;
      white-space: pre-line;
    }
    .coin_left {
      position: absolute;
      bottom: 26%;
      left: -2%;
      width: 23%;
    }
    .wheel {
      width: 80%;
      position: absolute;
      bottom: 3%;
      left: 0;
      z-index: 1;
    }
    .coin_right {
      position: absolute;
      bottom: 3%;
      right: -2%;
      width: 40%;
      z-index: 0;
    }
    .coin_front {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 40%;
      z-index: 1;
    }

  }
  .mtt {
    position: relative;
    .background{
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      text-align: center;
      position: relative;
      background-image: url('~@img/keyVisual/bg_10.png');
      background-position: bottom;
      background-size: contain;
      background-repeat: no-repeat;
      margin-top: 25%;
      width: 100%;
      height: 1600px;
      @media (max-width: $containerWidth) {
        height: pxToVw(1600px);
      }
    }
    .textBlock {
      width: 80%;
      margin-top:10%;
      white-space: pre-line;
      z-index: 1;
    }
    .confetti {
      position: absolute;
      top: -2%;
      display: flex;
      justify-content: center;
      .image {
        width: 94%;
        animation-delay: 300ms;
        animation:  zoom-in-zoom-out-once 1s forwards;
        -webkit-animation:  zoom-in-zoom-out-once 1s forwards;
      }
    }
  }
  .rg {
    position: relative;
    .background{
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      text-align: center;
      position: relative;
      padding-top: 20%;
      width: 100%;
    }
    .textBlock {
      position: relative;
      z-index: 2;
      margin-left: 8%;
      margin-right: 8%;
      margin-bottom: 8%;
      white-space: pre-line;
    }
    .section {
      position: relative;
      z-index: 2;
      margin-left: 8%;
      margin-right: 8%;
      white-space: pre-line;
    }

    .light {
      position:absolute;
      top: 10%;
      z-index: 1;
    }
    .bg_11 {
      position:relative;
      margin-top: 44%;
      z-index: 1;
    }
    .character {
      position: relative;
      width: 100%;
      z-index: 0;
     
    }
    .bg_11_king {
      position:absolute;
      bottom: 23%;
      width: 50%;
    }
   
    .confetti_11 {
      position: absolute;
      width: 100%;
      bottom: 3%;
      left: 0;
      z-index: 2;
      animation-delay: 300ms;
      animation: zoom-in-zoom-out-once 1s ease-in-out forwards;
      -webkit-animation: zoom-in-zoom-out-once 1s ease-in-out forwards;
    }
  }
  .zoomInAnimation.data-aos {
    animation-delay: 300ms;
    animation: zoom-in-zoom-out-once 1s ease-in-out forwards;
    -webkit-animation: zoom-in-zoom-out-once 1s ease-in-out forwards;
  }
}
</style>
